import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Platform } from '@ionic/angular';
import { CommunicationService } from '@takectrl-multiapp/svcs-core';
import { BUSNThirdPartyService } from '@takectrl-multiapp/svcs-core-business';
import { IInsurersDetails, SharedConfig, SharedDialogService } from '@takectrl-multiapp/svcs-share-config';
import { BUSNCommunicationService } from 'libs/svcs-core-business/src/lib/services/busn-communication.service';
@Component({
  selector: 'popup-dialog',
  standalone: false,
  templateUrl: './popup-dialog.component.html',
  styleUrls: ['./popup-dialog.component.scss'],
})
export class PopupDialogComponent implements OnInit {
  setBottom: boolean;
  href_string: string =
    'mailto:?to=MIDigitalSupport@momentum.co.za&subject=Momentum Insure Online Quoting tool - Technical support query';
  constructor(
    public sharedConfig: SharedConfig,
    public sharedDialogConfig: SharedDialogService, 
    public busnCommunicationService: BUSNCommunicationService,
    public busnThirdPartyService: BUSNThirdPartyService,
    private communicationService: CommunicationService, 
    private platform: Platform, 
  ) {}

  ngOnInit(): void {
    if (SharedConfig.showFooterTabs) {
      this.setBottom = true;
    } else {
      this.setBottom = false;
    }
  }

  // callInsurer(insurer: IInsurersDetails) {
  //   this.busnCommunicationService.callInsurer(insurer)
  // }

  callBroker() {
    this.closePopup()
    this.busnCommunicationService.callBroker();
  }

  openIntercom() {
    this.busnThirdPartyService.intercomDisplayLauncher();
    this.closePopup()
    const intervalId = setInterval(() => {
      SharedConfig.intercomBadgeCount = document.querySelector('[data-testid="active-notifications"]').innerHTML
        clearInterval(intervalId);
    }, 1000);
  }

  openWhatsApp() { 
    const phoneNumberWithCountryCode = "27" + this.sharedConfig.user.broker.whatsapp_number.slice(1);
    const url = `https://wa.me/${phoneNumberWithCountryCode}`; window.open(url, '_blank'); 
    this.closePopup()
  }

  callInsurer(insurer: IInsurersDetails) {
    this.closePopup()
    SharedConfig.showCustomLoader = true;
    let intervalId = setInterval(() => {
        if (this.platform.is('mobileweb')) {
          window.open('tel:' + insurer.contact_number, '_blank')
        } else if (this.platform.is('desktop')) {
          this.sharedDialogConfig.showPopupDialog({
            header: insurer.description + "'s number:",
            subHeader: insurer.contact_number,
            buttonOneText: 'OK',
            buttonOneCallback: this.sharedDialogConfig.hidePopupDialog,
          });
        } else {
          this.communicationService.makePhoneCall(insurer.contact_number);
        }
        SharedConfig.showCustomLoader = false;
        clearInterval(intervalId);
    }, 500);
  }

  closePopup() {
    this.sharedDialogConfig.hidePopupDialog();
  }

  buttonOneAction() {
    SharedConfig.popupDialogButtonOneCallBack();
  }

  buttonTwoAction() {
    SharedConfig.popupDialogButtonTwoCallBack();
  }

  buttonThreeAction() {
    SharedConfig.popupDialogButtonThreeCallBack();
  }

  onTextAreaChange(e: Event) {
    SharedConfig.popupDialogTextAreaValue = e.target['value'];
  }

  nextOnEnter(event) {
    const key = event.keyCode;
    if (key == 13) {
      this.buttonOneAction();
    }
  }
}
